import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { IPathNormativities } from "../../../models/storeModels/IPathNormativities";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { logout } from "../../../features/auth";

function getInitialState() {
    const initialState: IPathNormativities = {
        yearInfo: getItemWebStorage('diagnosticsYearFilters')?.pathNormativitiesInfo ?? `${new Date().getFullYear()}`,
        pathNormativitiesMapYearFilter: getItemWebStorage('diagnosticsYearFilters')?.pathNormativitiesMap ?? `${new Date().getFullYear()}`,
        pathNormativitiesMapMultipleMeasureTypes: {
            Roughness: true,
            Defects: false,
            GaugeDepth: false,
            Strength: false,
            Cohesion: false
        },
        pathNormativitiesMapNormativityFlag: true,
        pathNormativitiesMapUnionMode: 'intersection',
        hasChosenYearInfo: getItemWebStorage('diagnosticsYearFilters')?.pathNormativitiesInfo,
        hasChosenYearMapMeasureType: getItemWebStorage('diagnosticsYearFilters')?.pathNormativitiesMap,
        hasChosenYearMapMeasureTypesGroup: false,
        searchButtonIsClicked: false,
        pathNormativitiesSearchValue: null,
        pathNormativitiesMapFilters: getItemWebStorage("pathNormativitiesMapFilters") ??
        {
            isOnHighwayNetworkSegment: false,
            roadBedTypes: {
                ignoreRoadBedTypes: true
            },
            raions: {
                ignoreRaions: true
            }
        },
        pathNormativitiesMapFilterString: null,
        allRaionFilterValues: null,
        activeFiltersTabs: getItemWebStorage("pathNormativitiesMapFiltersActiveTabs"),
        pathNormativitiesMapFiltersAreExpanded: false,
        pathNormativitiesForMapTooltip: null
    }
    return initialState
}

export const pathNormativitiesSlice = createSlice({
    name: 'pathNormativities',
    initialState: getInitialState(),
    reducers: {
        setYearPathNormativitiesInfo(state, action: PayloadAction<any>) {
            state.yearInfo = action.payload
        },
        setYearPathNormativitiesMap(state, action: PayloadAction<any>) {
            state.pathNormativitiesMapYearFilter = action.payload
        },
        applyMeasureTypeOnMap(state, action: PayloadAction<any>) {
            const { Roughness, Defects, GaugeDepth, Strength, Cohesion } = action.payload
            state.pathNormativitiesMapMultipleMeasureTypes.Roughness = Roughness
            state.pathNormativitiesMapMultipleMeasureTypes.Defects = Defects
            state.pathNormativitiesMapMultipleMeasureTypes.GaugeDepth = GaugeDepth
            state.pathNormativitiesMapMultipleMeasureTypes.Strength = Strength
            state.pathNormativitiesMapMultipleMeasureTypes.Cohesion = Cohesion
        },
        setMapNormativityFlag(state, action: PayloadAction<any>) {
            state.pathNormativitiesMapNormativityFlag = action.payload
        },
        setMapUnionMode(state, action: PayloadAction<any>) {
            state.pathNormativitiesMapUnionMode = action.payload
        },
        setHasChosenYearPathNormativitiesInfo(state, action: PayloadAction<any>) {
            state.hasChosenYearInfo = action.payload
        },
        setHasChosenYearPathNormativitiesMapMeasureType(state, action: PayloadAction<any>) {
            state.hasChosenYearMapMeasureType = action.payload
        },
        setHasChosenYearPathNormativitiesMapMeasureTypesGroup(state, action: PayloadAction<any>) {
            state.hasChosenYearMapMeasureTypesGroup = action.payload
        },
        setPathNormativitiesActiveFiltersTabs(state, action: PayloadAction<any>) {
            state.activeFiltersTabs = action.payload
        },
        setPathNormativitiesSearchRoadClicked(state, action: PayloadAction<any>) {
            state.searchButtonIsClicked = action.payload
        },
        setPathNormativitiesSearchValue(state, action: PayloadAction<any>) {
            state.pathNormativitiesSearchValue = action.payload
        },
        setPathNormativitiesMapFilter(state, action: PayloadAction<any>) {
            state.pathNormativitiesMapFilters = action.payload
        },
        setPathNormativityAllRaionMapFilterValues(state, action: PayloadAction<any>) {
            state.allRaionFilterValues = action.payload
        },
        setPathNormativityMapFilterString(state, action: PayloadAction<any>) {
            state.pathNormativitiesMapFilterString = action.payload
        },
        setPathNormativitiesForMapTooltip(state, action: PayloadAction<any>) {
            state.pathNormativitiesForMapTooltip = action.payload
        },
        setPathNormativitiesMapFiltersAreExpanded(state, action: PayloadAction<any>) {
            state.pathNormativitiesMapFiltersAreExpanded = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setYearPathNormativitiesInfo,
    setYearPathNormativitiesMap,
    applyMeasureTypeOnMap,
    setMapNormativityFlag,
    setMapUnionMode,
    setHasChosenYearPathNormativitiesInfo,
    setHasChosenYearPathNormativitiesMapMeasureType,
    setHasChosenYearPathNormativitiesMapMeasureTypesGroup,
    setPathNormativitiesSearchRoadClicked,
    setPathNormativitiesSearchValue,
    setPathNormativitiesMapFilter,
    setPathNormativityAllRaionMapFilterValues,
    setPathNormativityMapFilterString,
    setPathNormativitiesActiveFiltersTabs,
    setPathNormativitiesForMapTooltip,
    setPathNormativitiesMapFiltersAreExpanded } = pathNormativitiesSlice.actions
export const pathNormativitiesReducer = pathNormativitiesSlice.reducer;
